import React from 'react'
import PropTypes from 'prop-types'
import { Div } from 'glamorous'

import ActionButton from 'components/actions/ActionButton'

const Actions = ({ actions }) => {
  return (
    <Div
      display="flex"
      flex={1}
      flexDirection="row"
      alignItems="center"
      justifyContent="space-around"
    >
      {actions.map(action => (
        <ActionButton
          key={action.key}
          icon={action.icon}
          onClick={action.onClick}
          size={action.size}
          disabled={action.disabled}
        />
      ))}
    </Div>
  )
}

Actions.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      icon: PropTypes.element.isRequired,
      onClick: PropTypes.func,
      size: PropTypes.size,
      disabled: PropTypes.bool
    })
  )
}

export default Actions



// WEBPACK FOOTER //
// ./src/components/actions/Actions.js